{
  "pageTitle": "Payment Processing",
  "noPendingHint": "Run scraping to import invoices.",
  "paymentComplete": "Payment complete",
  "progress": "Processing {{count}} of {{total}} invoice(s)",
  "progressDot": "Processing {{count}} of {{total}} invoice(s)...",
  "cancelPayment": "Cancel",
  "twoFaTitle": "2FA Required",
  "twoFaPlaceholder": "Enter OTP code",
  "twoFaSubmit": "Submit",
  "twoFaPaste": "Paste",
  "twoFaCancel": "Cancel",
  "paymentHistory": "Payment History",
  "historyClose": "Close",
  "invoicesToPay": "Invoices to Pay",
  "historyLoading": "Loading payment history...",
  "historyFailedTitle": "Failed to load payment history",
  "historyRetry": "Retry",
  "historyEmpty": "No payment logs yet.",
  "simulated": "Simulated",
  "invoices": "invoices",
  "clickToViewLogs": "Click to view logs",
  "logDetails": "Payment Log Details",
  "logCompleted": "Completed",
  "logFailed": "Failed",
  "logCancelled": "Cancelled",
  "logMessages": "Messages",
  "logEntries": "Entries",
  "paymentDetails": "Payment Log Details",
  "date": "Date",
  "status": "Status",
  "results": "Results",
  "logs": "Logs",
  "noMessages": "No messages for this job.",
  "paymentFailed": "Payment failed",
  "confirmPay": "Confirm & Pay",
  "selectAll": "Select all",
  "deselectAll": "Deselect all"
}
